import { not } from 'ramda'

export function dropdownButton() {
  const containers = $('.button-dropdown')
  const triggers = containers.find('.input-trigger')

  function uncheckedTrigger() {
    triggers.prop('checked', false)
  } 

  return ({    
    init() {
      $(window).on('click', function(e) {
        if (not(
          containers.has($(e.target)).length
        )) uncheckedTrigger()
      })
    }
  })
}